import type React from 'react';
import { useMemo } from 'react';
import { useTranslations } from 'use-intl';
import { SimpleSelect } from '@/components/simple-select';

function availablePeriods() {
  const years: { value: string; label: string }[] = [];
  const availablePeriods: { value: string; label: string }[] = [];
  for (const year of [2026, 2025, 2024]) {
    const d = new Date(year, 11, 31);
    years.push({
      value: `year:${d.toISOString()}`,
      label: d.toLocaleDateString(undefined, { year: 'numeric' }),
    });
    for (const month of [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0]) {
      const d = new Date(year, month, 2);
      if (d < new Date()) {
        availablePeriods.push({
          value: `month:${d.toISOString()}`,
          label: d.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
          }),
        });
      }
    }
  }
  return [years, availablePeriods];
}

const PeriodSelector: React.FC<{
  className?: string;
  onChange: (period: 'year' | 'month' | 'day', date: Date) => void;
  startDate: Date;
}> = ({ className, onChange, startDate }) => {
  const t = useTranslations('stats');
  const [years, months] = useMemo(() => availablePeriods(), []);
  const onValueChange = (v: string) => {
    const parts = v.split(':');
    const period = parts.shift();
    const date = parts.join(':');
    onChange(period as 'year' | 'month' | 'day', new Date(date));
  };
  return (
    <SimpleSelect
      defaultValue={years[0].value}
      onValueChange={onValueChange}
      className={className}
      prefix={t('period')}
      options={[
        { label: t('since_start'), value: `since:${startDate.toISOString()}` },
        ...years.map(({ value, label }) => ({
          value,
          label,
          group: t('year'),
        })),
        ...months.map(({ value, label }) => ({
          value,
          label,
          group: t('month'),
        })),
      ]}
    />
  );
};
PeriodSelector.displayName = 'PeriodSelector';

export { PeriodSelector };
